export default "__VITE_ASSET__Dxl1auio__"